import { useAuth } from "core/hooks";
import { AuthProvider } from "core/providers"

export const AuthProviderSetter = () => {
    AuthProvider.auth = useAuth();
    return null;
};